/** Экранирует html-тэги и амперсанд */
export const escapeHtml = (string: string) => {
  return string.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
};
